<template>
  <div v-loading="loading">
  <div v-if="contract.signed" >
    <el-row class="artist-submit-music container-card" >
      <el-col>
        <el-upload
            drag
            ref="upload"
            :action="sendUrl"
            :headers="headers"
            accept=".mp3"
            :file-list="fileList"
            :on-success="onSuccess"
            :on-error="onError"
            :on-progress="uploadFile"
            name="uploaded"
            multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em><br>
            (only mp3 files allowed)
          </div>
          <!--<div class="el-upload__tip" slot="tip">*only mp3 files allowed</div>-->
        </el-upload>
      </el-col>
    </el-row>
    <el-row class="container-card">
      <el-col :span="24">
        <el-card v-loading="loading">
          <div class="data-title flex-space-between" slot="header">
            <p>Submit Music</p>
            <div>
              <DialogTrack />
            </div>
          </div>
          <el-table :data="approval.data" class="w100" stripe>
            <el-table-column
                label="Cover"
                prop="image_url"
            >
              <template slot-scope="props">
                <img
                    v-if="props.row.image_url"
                    class="avatar"
                    :src="props.row.image_url"
                />
                <img
                    v-else
                    class="avatar"
                    :src="`https://app.syncvault.com/static/apple-touch-icon.png`"
                />
              </template>
            </el-table-column>
            <el-table-column
                label="Title"
                prop="title"
                sortable
            ></el-table-column>
            <el-table-column
                label="ISRC"
                prop="isrc"
                sortable
            ></el-table-column>
            <el-table-column
                label="Spotify link"
                prop="spotify_link"
                sortable
            ></el-table-column>
            <el-table-column label="Actions" align="right" width="210%">
              <template slot-scope="props">
                <el-tooltip
                    content="Publish"
                    placement="top"
                    v-if="!props.row.user_publish"
                >
                  <el-button
                      type="success"
                      circle
                      size="small"
                      icon="el-icon-top"
                      @click="publish(props.row.id)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="Edit" placement="top" v-if="!props.row.user_publish">
                  <el-button
                      type="warning"
                      circle
                      size="small"
                      icon="el-icon-edit"
                      @click="openEdit(props.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                    content="Delete"
                    placement="top"
                    v-if="!props.row.user_publish"
                >
                  <el-button
                      type="danger"
                      circle
                      size="small"
                      icon="el-icon-close"
                      @click="deleteT(props.row.id)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
  <el-row class="artist-submit-music container-card" v-loading="loading" v-else>
    <el-col>
      <div class="artist-agreement">
        <p>Please read and sign Agreement for Promotion</p>
        <el-form ref="contract" :model="contract" label-position="top">
          <el-form-item label="First Name" prop="first_name">
            <el-input type="text" v-model="contract.first_name" clearable />
          </el-form-item>
          <el-form-item label="Last name" prop="last_name">
            <el-input type="text" v-model="contract.last_name" clearable />
          </el-form-item>
          <el-form-item label="Address" prop="address">
            <el-input type="text" v-model="contract.address" clearable />
          </el-form-item>
          <el-form-item label="Company name" prop="company_name">
            <el-input type="text" v-model="contract.company_name" clearable />
          </el-form-item>
          <el-form-item label="Company address" prop="company_address">
            <el-input type="text" v-model="contract.company_address" clearable />
          </el-form-item>
        </el-form>
        <el-checkbox v-model="agree">I agree signing <span class="contract-link" @click="generateContract()">this</span> contract</el-checkbox>
        <el-button class="btn-main btn-artist-contract-next" type="primary" :disabled="!agree" @click="sign()">
          Next
        </el-button>
      </div>
    </el-col>
  </el-row>
  <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1122"
      filename="PDF Reports"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="795px"
      :html-to-pdf-options="htmlToPdfOptions"
      ref="html2Pdf"
  >
    <section slot="pdf-content">
      <TrackContract />
    </section>
  </vue-html2pdf>
  </div>
</template>

<script>

import {mapActions, mapMutations, mapState} from "vuex";
import DialogTrack from "@/modules/artist/tracks/components/DialogTrack";
import VueHtml2pdf from 'vue-html2pdf'
import TrackContract from '@/modules/artist/tracks/components/TrackContract'

export default {
  data() {
    return {
      fileList: [],
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      url: process.env.VUE_APP_ARTIST_API_URL,
      agree: false,
      htmlToPdfOptions: {
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        enableLinks: true,
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        },
        filename: 'file.pdf'
      },
    }
  },
  components: {
    DialogTrack,
    VueHtml2pdf,
    TrackContract
  },

  computed: {
    ...mapState('artistDashboard', ['artist_label']),
    ...mapState('artistTracks', [
      'loading',
      'tracks',
      'approval',
      'contract'
    ]),
    ...mapState('auth', ['artist']),
    sendUrl: function() {
      if (this.artist_label !== null) {
        return this.url + 'mytracks/upload/track?artist=' + this.artist_label.id
      }
      return this.url + 'mytracks/upload/track'
    }
  },
  watch: {
    artist_label: function(valN, valO) {
      if (valN !== null) {
        this.readForApproval()
        this.checkContract()
      }
    }
  },
  methods: {
    ...mapActions('artistTracks', [
      'readMyTracks',
      'readForApproval',
      'deleteTrack',
      'deleteImage',
      'confirmTrack',
      'userPublish',
      'createContract',
      'signContract',
      'checkContract'
    ]),
    ...mapMutations('artistTracks', [
      'setLoading',
      'setTrack',
      'setDialogTrack',
      'setUploadImage',
      'setContract'
    ]),

    onSuccess() {
      this.readForApproval()
      this.setLoading(false)
    },
    onError(err) {
      var res = JSON.parse(err.message)
      this.setLoading(false)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },
    uploadFile() {
      this.setLoading(true)
    },
    close(){
      this.fileList = []
    },
    publish(id) {
      this.$confirm('You will publish this track. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => {
            this.userPublish(id)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Publish cancelled'
            })
          })
    },

    deleteT(id) {
      this.$confirm(
          'You will permanently delete this track. Continue?',
          'Warning',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
      )
          .then(() => {
            this.deleteTrack(id)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Delete cancelled'
            })
          })
    },

    openEdit(track) {
      this.setDialogTrack(true)
      this.setTrack(track)
      this.setUploadImage(track.image_url)
    },

    sign(){
      this.contract.artist_id = (this.artist_label != null) ? this.artist_label.id : ((this.artist != null) ? this.artist.id : null)
      this.signContract().then(() => {
        this.contract.signed = 1;
      })
    },

    generateContract() {
      if((!_.isEmpty(this.contract.first_name) && !_.isEmpty(this.contract.last_name) && !_.isEmpty(this.contract.address)) ||
          (!_.isEmpty(this.contract.company_name) && !_.isEmpty(this.contract.company_address))){
          this.contract.artist_id = (this.artist_label != null) ? this.artist_label.id : ((this.artist != null) ? this.artist.id : null)
          this.createContract().then(() => {
            this.setLoading(true)
            let filename = 'contract_syncvault'
            this.htmlToPdfOptions.filename = filename + '.pdf'
            setTimeout(() => {
              this.$refs.html2Pdf.generatePdf()
              this.setLoading(false)
            }, 1000)
          })
      }
      else{
        this.$message({
          type: 'error',
          message: 'You need to fill person info or company info'
        })
      }
    }
  },
  created() {
    this.readForApproval()
    this.checkContract()
  }
}
</script>
